// extracted by mini-css-extract-plugin
module.exports = {"checkoutTermsButton":"AcceptTermsInput_checkoutTermsButton__VCOvj","checkboxInput":"AcceptTermsInput_checkboxInput___XGvy","acceptTerms":"AcceptTermsInput_acceptTerms__55S0q"};